/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * "
 * State of the validation requirement
 */
export var ValidationRequirementState;

(function (ValidationRequirementState) {
  ValidationRequirementState["VERIFIED"] = "verified";
  ValidationRequirementState["MATCHED"] = "matched";
  ValidationRequirementState["PENDING"] = "pending";
})(ValidationRequirementState || (ValidationRequirementState = {}));